import { ListItem, ListItemText, Radio, makeStyles } from '@material-ui/core';
import * as React from 'react';
import { useCallback } from 'react';

const useStyles = makeStyles({
  radioButton: { padding: 0 }
});

interface Props<TClickData extends object> {
  checked: boolean;
  label: string;

  clickData: TClickData;
  onClick: (event: TClickData) => void;
}

export const ListItemRadio = <TClickData extends object>({
  onClick,
  clickData,
  checked,
  label
}: Props<TClickData>) => {
  const classes = useStyles();
  const handleListItemClick = useCallback(
    () => onClick(clickData), //
    [onClick, clickData]
  );

  return (
    <ListItem button dense onClick={handleListItemClick}>
      <Radio className={classes.radioButton} checked={checked} disableRipple />
      <ListItemText>{label}</ListItemText>
    </ListItem>
  );
};
